import { Injectable, Injector } from "@angular/core";
import { MfBaseService, MfTypeInfo } from "@pattonair/material-framework";

const TYPE_INFO: MfTypeInfo = { className: "AucFeatureService" };

// export type AucFeaturesChangedEvent = {
//   customer: AucCustomerModel;
//   features: AucRoleFeatureTypes[];
// };

@Injectable({ providedIn: "root" })
export class AucFeatureService extends MfBaseService {
  // protected _onFeaturesChangeSubject: ReplaySubject<AucFeaturesChangedEvent> = new ReplaySubject(1);
  // protected _onFeaturesChange = this._onFeaturesChangeSubject.asObservable();

  public constructor(
    protected override _injector: Injector,
  ) {
    super(TYPE_INFO, _injector);
  }

  // public get onFeaturesChange(): Observable<AucFeaturesChangedEvent> {
  //  return of({});
  // }

  // public has(hasFeatures: AucRoleFeatureTypes | AucRoleFeatureTypes[]): Observable<boolean> {
  //   return this.onFeaturesChange.pipe(
  //     map((featuresChangeEvent) => {
  //       if (Array.isArray(hasFeatures)) {
  //         return hasFeatures.every(hasFeature => featuresChangeEvent.features.includes(hasFeature));
  //       } else {
  //         return featuresChangeEvent.features.includes(hasFeatures);
  //       }
  //     }),
  //   );
  // }

  // protected _onCustomerChanged(customer: AucCustomerModel): void {
  //   this._onFeaturesChangeSubject.next({ customer, features: customer.features as AucRoleFeatureTypes[] });
  // }
}